import PatientSearchForm from './PatientSearchForm';

export default PatientSearchForm;



// WEBPACK FOOTER //
// ./src/views/components/PatientSearchForm/index.js